import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SetCursorPositionCommand from './setcursorpositioncommand.js';
import SetCursorPositionEditing from './setcursorpositionediting.js';

export default class NumberedCitation extends Plugin {
  static get pluginName() {
    return 'SetCursorPosition';
  }
  static get requires() {
    return [ SetCursorPositionEditing, SetCursorPositionCommand ];
  }
}
